module.exports = __webpack_public_path__ + "img/angpao.1d041837.gif";